module.exports = __webpack_public_path__ + "img/c.72369c99.jpg";